import Slider from './Slider';
import { sliderFotos } from "../SliderData/SliderDataWedding";

export const SliderWedding = () => {
    return (<Slider list={sliderFotos}/>)
};
